import { useQueryClient } from '@tanstack/react-query'

import {
  useIndividualsServiceDeleteV1IndividualsByIndividualId,
} from '../client/queries'
import {
  useUsersServiceGetV1UsersMeKey,
} from '../client/queries/common'

export const useDeleteIndividual = () => {
  const queryClient = useQueryClient()

  return useIndividualsServiceDeleteV1IndividualsByIndividualId({
    // Returned, not fired and forgotten: the caller navigates away as soon as
    // mutateAsync resolves, and without awaiting the refetch it would land on a
    // page still holding the deleted individual.
    onSuccess: () => {
      return queryClient.invalidateQueries({
        queryKey: [useUsersServiceGetV1UsersMeKey],
      })
    },
  })
}
